(() => {
  if (window.productVideoConsentHandlerBound) return;
  window.productVideoConsentHandlerBound = true;

  const openConsentPreferences = () => {
    const pandectes = document.querySelector('pandectes-cmp');
    const shadowTrigger =
      pandectes?.shadowRoot?.querySelector('button[aria-label="Modifier votre consentement"]') ||
      pandectes?.shadowRoot?.querySelector('button[aria-haspopup="dialog"]');

    if (shadowTrigger) {
      shadowTrigger.click();
      return true;
    }

    const documentTrigger = document.querySelector('[aria-label="Modifier votre consentement"]');
    if (documentTrigger) {
      documentTrigger.click();
      return true;
    }

    return false;
  };

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const trigger = event.target.closest('[data-product-video-consent]');
    if (!trigger) return;

    openConsentPreferences();
  });
})();
